export const comments_3787340 = {"data":{"data":[],"links":{}}}